'use client';

import { useContext, type FC } from 'react';
import { Button, Flex } from '@/_components';
import type { DocumentsNavigationProps } from './DocumentsNavigation.types';
import { DocumentsContext } from '@/_contexts/DocumentsProvider';

export const DocumentsNavigation: FC<DocumentsNavigationProps> = ({
  className,
}) => {
  const { loadRootDirectories, openDirectory, reloadDocuments } =
    useContext(DocumentsContext);

  const isRoot: boolean = openDirectory === '';

  const onReset = () => {
    reloadDocuments('');
    loadRootDirectories(true); // ensure the tree resets with all folders collapsed
  };

  return (
    <Flex className={className}>
      {!isRoot && (
        <Button
          value="Home"
          isIconOnly={true}
          onClick={onReset}
          withTooltip={true}
          intent="secondary"
          iconLeft="home"
        />
      )}
    </Flex>
  );
};
